import { useState, useEffect } from "react";
import { navItems } from "@/mocks/homeContent";

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-[1280px] items-center justify-between px-4 py-3 md:px-6">
        {/* brand */}
        <a href="#current" className="group flex items-center gap-2.5">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              吃瓜地址
            </span>
            <span className="mt-1 text-[11px] font-medium text-foreground-500">
              历史版本 · 换新地址 · 往期入口
            </span>
          </span>
        </a>

        {/* desktop nav */}
        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="rounded-md px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="#subscribe"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-add-line mr-1"></i>获取最新地址
          </a>
        </div>

        {/* mobile toggle */}
        <button
          type="button"
          aria-label="菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-background-200 text-foreground-800 lg:hidden"
        >
          <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-3-line"}`}></i>
        </button>
      </div>

      {/* mobile panel */}
      {open && (
        <div className="border-t border-background-200 bg-background-50/98 px-4 py-3 lg:hidden">
          <nav className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-lg bg-background-100 px-3 py-2.5 text-sm font-medium text-foreground-800"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <a
            href="#subscribe"
            onClick={() => setOpen(false)}
            className="mt-3 flex items-center justify-center whitespace-nowrap rounded-lg bg-primary-500 px-4 py-3 text-sm font-semibold text-background-50"
          >
            <i className="ri-add-line mr-1"></i>获取最新地址
          </a>
        </div>
      )}
    </header>
  );
}

export default Header;